<nav class="registrations-header-container d-flex align-items-stretch justify-content-start navbar p-0" *ngIf="dataLoaded">
    <div class="header-item">
        <h5>Reg ID: {{registrationProfileData.registration.id ? registrationProfileData.registration.id : "N/A"}}<br>
          <span *ngIf="registrationProfileData.registration && registrationProfileData.registration && !registrationProfileData.registration.middleInitial">
            {{registrationProfileData.registration.firstName}} {{registrationProfileData.registration.lastName}}
          </span>
          <span *ngIf="registrationProfileData.registration && registrationProfileData.registration && registrationProfileData.registration.middleInitial">
            {{registrationProfileData.registration.firstName}} {{registrationProfileData.registration.middleInitial}} {{registrationProfileData.registration.lastName}}
          </span>
        </h5>
    </div>

    <div class="header-item" *ngIf="customerData.customerName">
      <h6>{{customerData.customerName}} ({{customerData.state}})</h6>
    </div>

    <div *ngIf="dateModified != 'Invalid date'" class="header-item">
        <div>
            Last Modified by <span>{{modifiedBy}}</span> :
        </div>
        <div>
            {{dateModified}}
        </div>
    </div>

    <div class="header-item d-flex flex-column justify-content-center">
        <h5>Reg Total</h5>
        <h5>{{getRegTotal() | currency}}</h5>
    </div>

    <div class="header-item" id="payment">
        <div class="row">
            <div class="col-4 d-flex justify-content-between align-items-center currency-item">
                <p>Revenue in Hand:</p>
                <p class="text-success">{{getRevenueInHand() | currency}}</p>
              </div>
              <div class="col-4 d-flex justify-content-between align-items-center currency-item">
                <p>Parent Payment Pending:</p>
                <p class="text-primary">{{getParentPaymentPending() | currency}}</p>
              </div>
              <div class="col-4 d-flex justify-content-between align-items-center currency-item">
                <p>Unallocated:</p>
                <p class="text-danger">{{getUnallocated() | currency}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-4 d-flex justify-content-between align-items-center currency-item">
                <p>Tax:</p>
                <p class="text-success">{{getRevenueInHandTax() | currency}}</p>
              </div>
              <div class="col-4 d-flex justify-content-between align-items-center currency-item">
                <p>School Payment Pending:</p>
                <p class="text-primary">{{getSchoolPaymentPending() | currency}}</p>
              </div>
              <div class="col-4 d-flex justify-content-between align-items-center currency-item">
                <p>Payment Owed:</p>
                <p class="text-danger">{{getPaymentOwed() | currency}}</p>
              </div>
        </div>
    </div>

    <div class="header-item d-flex" id="navButtons" *ngIf="historyLoaded">
        <div class="header-button">
          <img class="image-box" *ngIf="customerData.hasAuthorizeNet"
            src="/assets/misc/reg-edit-anet-logo.jpg"
            title="This customer has an edPayment module configured with Authorize.net">
        </div>

        <div class="header-button font-weight-bold">

          <app-text-pop-up [config]="ncaaPopUpConfig">
            <div [ngClass]="['button-text', ncaaNoData ? 'pop-up-no-data' : '']" id="ncaaButton" textPopUpOpen>
              <span>NCAA</span>
            </div>
            <span class="tool-tip-text p-2" textPopUpContent>

              <div class="row">
                <div class="col-12">
                  <app-srs-checkbox [config]="ncaaProspectCheckboxConfig"></app-srs-checkbox>
                  <app-srs-form-field [config]="ncaaFormFieldConfig"></app-srs-form-field>
                </div>
                <div class="col-12 d-flex justify-content-end">
                  <button class="btn btn-secondary" (click)="submitNcaaInfo()" [disabled]="ncaaFormGroup.isOriginal">Submit</button>
                </div>
              </div>
            </span>
          </app-text-pop-up>
        </div>

        <div class="header-button font-weight-bold">

          <app-text-pop-up [config]="iepPopUpConfig" >
            <div [ngClass]="['button-text', iepNoData ? 'pop-up-no-data' : '']" id="iepButton" textPopUpOpen>
              <span>IEP</span>
            </div>
            <span class="tool-tip-text p-2" textPopUpContent>

              <div class="row">
                <div class="col-12">
                  <app-srs-checkbox [config]="iepCheckboxConfig"></app-srs-checkbox>
                  <app-srs-text-area [config]="iepTextAreaConfig" #iepTextArea></app-srs-text-area>
                </div>
                <div class="col-12 d-flex justify-content-end">
                  <button class="btn btn-secondary" (click)="submitIepInfo()" [disabled]="iepFormGroup.isOriginal">Submit</button>
                </div>
              </div>
            </span>
          </app-text-pop-up>
        </div>


        <div class="header-button font-weight-bold">

          <app-text-pop-up [config]="fncPopUpConfig">
            <div [ngClass]="['button-text', fncNoData ? 'pop-up-no-data' : '']" id="fncButton" textPopUpOpen>
              <i class="fas fa-exclamation"></i>
            </div>
            <span class="tool-tip-text p-2" textPopUpContent>

              <div class="row">
                <div class="col-12">
                  <app-srs-checkbox [config]="fncCheckboxConfig"></app-srs-checkbox>
                  <app-srs-text-area [config]="fncTextAreaConfig"></app-srs-text-area>
                </div>
                <div class="col-12 d-flex justify-content-end">
                  <button class="btn btn-secondary" (click)="submitFncInfo()" [disabled]="fncFormGroup.isOriginal">Submit</button>
                </div>
              </div>
            </span>
          </app-text-pop-up>

        </div>

        <div class="header-button font-weight-bold">
          <app-text-pop-up [config]="popUpConfig">
            <div [ngClass]="['button-text', historyNoData ? 'pop-up-no-data' : '']" id="historyButton" textPopUpOpen>
              <span>H</span>
            </div>
            <span id="history" class="tool-tip-text" textPopUpContent>
              <p><u><b>Student History</b></u></p>
              <table *ngIf="historyDetails.length > 0; else noHistory">
                <thead>
                  <tr>
                    <th>Reg ID</th>
                    <th>Date Created</th>
                    <th>Total Fee</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let d of historyDetails">
                    <td><a [routerLink]="'/registrations/' + d.regId" target="_blank">{{d.regId}}</a></td>
                    <td>{{formatDate(d.dateCreated)}}</td>
                    <td>{{d.totalFee | currency}}</td>
                  </tr>
                </tbody>
              </table>
              <ng-template #noHistory>
                <p>There is no registration history for this student.</p>
              </ng-template>
            </span>
          </app-text-pop-up>
        </div>

        <div class="header-button font-weight-bold" >
          <app-text-pop-up [config]="popUpConfig">
            <div class="button-text" id="cartButton" [class]="registrationProfileData.registration.cartStatus" textPopUpOpen>
              <i class="far fa-shopping-cart"></i>
            </div>
            <span class="tool-tip-text" textPopUpContent>
              <p><u><b>Cart Status</b></u></p>
              {{registrationProfileData.registration.cartStatus ? registrationProfileData.registration.cartStatus : "N/A" }}
            </span>
          </app-text-pop-up>
        </div>
    </div>
</nav>
